<cb-table
    class="cb-margin-2x flex"
    label="Change Records"
    [stringColumns]="displayedColumns"
    [loaded]="changeRecordsLoaded"
    emptyMessage="There are no Changes related to this RFI"
>
    @for (changeRecord of changeRecords; track changeRecord) {
        <tr cbTableRow>
            <td>{{ changeRecord.changeNumber }}</td>
            <td>
                {{ COST_NATURE_ENUM[changeRecord.costNature] }}
            </td>
            <td>{{ changeRecord.changeDetails | cbDasher }}</td>
            <td>{{ changeRecord.assignedTo | cbDasher }}</td>
            <td>
                {{ CHANGE_STATUS_ENUM[changeRecord.changeStatus] }}
            </td>
            <td cbTableShrinkCol cbTableStickyCol="end">
                <button mat-icon-button (click)="viewChangeRecord($event, changeRecord)">
                    <mat-icon>pageview</mat-icon>
                </button>
            </td>
        </tr>
    }
</cb-table>
